<template>
  <main>
    <Banner />
    <Achievements />
    <Separator type="try" />

    <Problem />
    <About />
    <Separator type="question" />

    <Solution />
    <Generator />
    <Separator type="contact" />

    <Pricing />
    <Separator type="ready" />
  </main>
</template>

<script>
import Banner from './components/banner/index.vue'
import Problem from './components/problem/index.vue'
import Generator from './components/generator/index.vue'
import Solution from './components/solution/index.vue'
import About from './components/about/index.vue'
import Achievements from './components/achievements/index.vue'
import Pricing from './components/pricing/index.vue'
import Separator from '@components/separator/Separator.vue'

export default {
  name: 'Home',
  components: { Banner, Problem, Generator, Solution, About, Pricing, Achievements, Separator },
  setup() {},
}
</script>
